<template>
  <div class="is-flex"
    :content="fullName"
    v-tippy="{ enabled: true }">
    <svg-circle v-if="isTextProfile"
      name="userProfile"
      :text="initials"
      :width="width"
      :height="height" />
    <img v-else
      name="userProfileIcon"
      :src="base64Image"
      class="is-rounded"
      :style="`width: ${width}px;`"
      aria-haspopup="true"
      aria-expanded="false">
  </div>
</template>

<script>
import SvgCircle from '@/components/SvgCircle/SvgCircle'
import { getInitials, getFullName } from '@/utils/PersonNameFunctions'

export default {
  name: 'UserProfileIcon',
  components: { SvgCircle },
  mixins: [],
  props: {
    width: {
      type: Number,
      default: 30
    },
    height: {
      type: Number,
      default: 30
    },
    isTextProfile: {
      type: Boolean,
      default: true
    },
    firstName: {
      type: String,
      default: null
    },
    lastName: {
      type: String,
      default: null
    },
    displayName: {
      type: String,
      default: null
    }
  },
  data: () => {
    return {
      base64Image: 'https://i.pravatar.cc/300',
      initials: '',
      fullName: ''
    }
  },
  computed: {},
  watch: {},
  created() {
    this.getUserProfileNames()
  },
  mounted() {},
  methods: {
    getUserProfileNames() {
      const names = { firstName: this.firstName, lastName: this.lastName, displayName: this.displayName }
      this.initials = getInitials(names)
      this.fullName = getFullName(names)
    }
  }
}
</script>

<style lang="scss">
.is-rounded {
  border-radius: 50%;
}
</style>
